// extracted by mini-css-extract-plugin
module.exports = {"answersWrapper":"MissingElements_answersWrapper__2NYHo","answersInner":"MissingElements_answersInner__39Qb4","boardBox":"MissingElements_boardBox__2JsCP"};